// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

// ** Requests
export const getRequestsList = createAsyncThunk('appRequests/getRequestsList', async params => {
   params.page = params.page === 0 ? 0 : params.page - 1
   const response = await axios.post(`https://api.mfauto.com.ua/requests/list?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...params,
      token: localStorage.getItem('token')
   })

   return {
      params,
      data: response.data.requests,
      totalPages: response.data.total_elements,
      statusCounts: response.data.status_counts,
      error: response.data.error
   }
})

export const addRequest = createAsyncThunk('appRequests/addRequest', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/requests/add?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})

export const updateRequest = createAsyncThunk('appRequests/updateRequest', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/requests/edit?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})

export const changeRequestStatus = createAsyncThunk('appRequests/changeRequestStatus', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/requests/status?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})

export const attachRequestLead = createAsyncThunk('appRequests/attachRequestLead', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/requests/attach?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})

export const detachRequestLead = createAsyncThunk('appRequests/detachRequestLead', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/requests/detach?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})

export const getRequest = createAsyncThunk('appRequests/getRequest', async (id) => {
   const response = await axios.post(`https://api.mfauto.com.ua/requests/get?env=${process.env.REACT_APP_NODE_ENV}`, {
      id,
      token: localStorage.getItem('token')
   })
   return response.data
})

export const removeRequest = createAsyncThunk('appRequests/removeRequest', async (id) => {
   const response = await axios.post(`https://api.mfauto.com.ua/requests/remove?env=${process.env.REACT_APP_NODE_ENV}`, {
      id,
      token: localStorage.getItem('token')
   })
   return response.data
})

export const appRequestsSlice = createSlice({
   name: 'appRequests',
   initialState: {
      data: [],
      total: 1,
      params: {},
      statusCounts: {},
      selectedRequest: null
   },
   reducers: {},
   extraReducers: builder => {
      builder
      .addCase(getRequestsList.fulfilled, (state, action) => {
         state.data = action.payload.data
         state.params = action.payload.params
         state.total = action.payload.totalPages
         state.statusCounts = action.payload.statusCounts
      })
      .addCase(getRequest.fulfilled, (state, action) => {
         state.selectedRequest = action.payload
      })
   }
})

export default appRequestsSlice.reducer
